import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    printingOuterContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 0px 24px',
      minWidth: '100%',
      background: 'transparent'
    },
    printingInnerContainer: {
      background: 'white',
      color: '#2A2A2A',
      minWidth: '100%',
      borderRadius: '8px',
      height: '879px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        height: '1700px',
        flexDirection: 'column-reverse',
        justifyContent: 'flex-end'
      }
    },
    printingTextContainer: {
      padding: '0 140px',
      alignItems: 'center',
      justifyContent: 'center',
      borderRight: '1px solid #D8D8D8',
      background: 'transparent',
      display: 'grid'
    },
    printingImageContainer: {
      [theme.breakpoints.down('lg')]: {
        height: '53%'
      }
    },
    printingTextBox: {
      width: '660px',
      margin: '0px 0px 56px 0px',
      background: 'transparent',
      textAlign: 'center'
    },
    printingHeaderContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      background: 'transparent',
      padding: '0px 16px 0px 16px',
      margin: '0px 0px 48px 0px'
    }
  })
);
